import React from 'react'

function TrashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon/Trash Can">
        <path id="Union" fillRule="evenodd" clipRule="evenodd" d="M6 1C5.44772 1 5 1.44772 5 2V3H3.5H2V4H3V14C3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14V4H14V3H12.5H11V2C11 1.44772 10.5523 1 10 1H6ZM10 3V2H6V3H10ZM6 5V13H7V5H6ZM9 13V5H10V13H9ZM4 14V4H12V14H4Z" fill="#161616"/>
      </g>
    </svg>
  )
}

export default TrashIcon
